import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ProblemWindowComponent } from './problem-window/problem-window.component';

@Injectable({ providedIn: 'root' })
export class ReportProblemService {
  constructor(private httpClient: HttpClient, public dialog: MatDialog) {}

  public sendReport(payload: {
    id: string;
    type: string;
    description: string;
    comments: string;
  }): Observable<any> {
    const url = `${environment.apiUrl}/configs/problem`;
    return this.httpClient.post<any>(url, payload);
  }

  public show(
    id: string | undefined,
    type: string | undefined,
    description: string | undefined
  ): void {
    this.dialog.open(ProblemWindowComponent, {
      data: { id, type, description },
      closeOnNavigation: true,
      disableClose: true,
      panelClass: 'problem-panel',
    });
  }
}
